<div class="progress-bar_outer">
  <div class="progress-bar_inner" [style.width]="progressPercent + '%'"></div>
</div>
